import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { LanguageFieldsActionType, LanguageFieldsStoreElement } from './LanguageFieldsReducer.types';

const initialState = Immutable.fromJS({
  fetching: false,
  fields: null,
});

export const LanguageFieldsReducer = handleActions(
  {
    RESPONSE_LANGUAGE_TOKENS: (state: LanguageFieldsStoreElement, action: LanguageFieldsActionType) => {
      return state
        .set('fetching', false)
        .set('fields', Immutable.fromJS(action.payload.regular))
        .set('combo', Immutable.fromJS(action.payload.combo))
        .set('selection', Immutable.fromJS(action.payload.selection));
    },

    REQUEST_LANGUAGE_FIELDS: (state: LanguageFieldsStoreElement) =>
      Immutable.fromJS({
        fetching: true,
        fields: null,
      }) as any,
    RESPONSE_LANGUAGE_TOKENS_FAILURE: (state: LanguageFieldsStoreElement) =>
      state.merge(
        Immutable.fromJS({
          fetching: false,
        })
      ),
    // @ts-ignore
    AUTHENTICATION_LOGOUT: () => initialState,
  },
  initialState
);
